import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "account-tab-container" }
const _hoisted_2 = { class: "account-tab-list" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "account-tab-content" }

import { computed, ref } from 'vue'
import { HoldingsMutationTypes } from '@/store/modules/holdings/mutations-type'
import { useStore } from 'vuex'


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountTypeTab',
  setup(__props) {

const store = useStore<any>()

// 账户类型列表
const accountTab = ref([
  {
    label: '证劵账户',
    value: 'STOCK'
  },
  {
    label: '基金账户',
    value: 'FUND'
  },
  {
    label: '债券账户',
    value: 'BOND'
  },
  {
    label: '结构化票据账户',
    value: 'SPS'
  }
])

const accountTypeActive = computed(() => {
  return store.state.holdings.accountTypeActive
})

// 账户类型点击
const accountTypeClick = (item: { label: string, value: string }) => {
  switch (item.value) {
    case 'STOCK':
      store.commit(HoldingsMutationTypes.SET_MARKET_TYPE_ACTIVE, { label: '港股', value: 'HK' })
      break
    case 'FUND':
      store.commit(HoldingsMutationTypes.SET_MARKET_TYPE_ACTIVE, { label: '港元账户', value: 'HKD' })
      break
    case 'BOND':
      store.commit(HoldingsMutationTypes.SET_MARKET_TYPE_ACTIVE, { label: '港元债券', value: 'HKD' })
      break
    case 'SPS':
      break
  }
  store.commit(HoldingsMutationTypes.SET_ACCOUNT_TYPE_ACTIVE, item)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accountTab.value, (item) => {
        return (_openBlock(), _createElementBlock("span", {
          class: _normalizeClass(['account-tab-item-label', item.value === accountTypeActive.value.value ? 'active' : '']),
          key: item.label,
          onClick: ($event: any) => (accountTypeClick(item))
        }, _toDisplayString(item.label), 11, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})